import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import {
  footer1,
  footer2,
  footer3,
  footer4,
  footer5,
  logo,
} from "../../assets/images";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz

  const [settings, setSettings] = useState([]);
  const [allCategories, setCategories] = useState([]);

  useEffect(() => {
    getSettings();
    getCategories();
  }, []);

  async function getSettings() {
    try {
      // API'den verileri çekiyoruz
      const response = await axios.get(
        "https://www.elzabeauty.az/elza/settings.php"
      );
      setSettings(response.data.data[0]); // Gelen veriyi state'e kaydediyoruz
    } catch (error) {
      console.error("Error fetching categories:", error); // Hata durumunda mesaj yazdırıyoruz
    }
  }

  const getCategories = async () => {
    try {
      const response = await axios.get(
        `https://www.elzabeauty.az/elza/categories.php`,
        { withCredentials: false }
      );
      setCategories(response.data.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const getLocalizedField = (item, fieldBase) => {
    if (currentLanguage === "en")
      return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === "ru")
      return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase];
  };

  return (
    <div className="mt-10 md:mt-20">
      <footer className="bg-[white] text-white">
        <div className="max-w-containerSm md:max-w-container mx-auto pt-10">
          <div className="md:flex justify-between pb-8 border-b-[1px] border-[#979797]">
            <div className="md:w-[110px]">
              <img alt="Logo" className="w-[80px]" src={logo}></img>
              {/* <p className='text-[17px] mt-[20px] md:mt-[40px] font-thirdFont'>{t("Lazer, stomotoloji və kosmetoloji məhsulların satışı və servisi")}</p> */}
              <ul className="space-y-2 md:space-y-2 text-[#7D7D7D] mt-5">
                <div className="flex gap-2 items-center">
                  <a href={settings.whatsapp}>
                    <img alt="Whatsapp" className="w-6 h-6" src={footer1}></img>
                  </a>
                  <a href={settings.instagram}>
                    {" "}
                    <img alt="Instagram" className="w-6 h-6" src={footer2}></img>
                  </a>
                  <a href={settings.tiktok}>
                    <img alt="Tiktok" className="w-6 h-6" src={footer3}></img>
                  </a>
                </div>
              </ul>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 md:w-[960px]">
              <div className="md:w-[135px] mt-10 md:mt-0 text-[#DCDCDC]">
                <h4 className="font-medium text-[18px] text-[#222222]">
                  {t("Sürətli Keçidlər")}
                </h4>
                <ul className="space-y-2 md:space-y-2 mt-5 text-[#7D7D7D]">
                  <li>
                    <a
                      href={`/${currentLanguage}/about`}
                      className="hover:underline"
                    >
                      {t("Haqqımızda")}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`/${currentLanguage}/products`}
                      className="hover:underline"
                    >
                      {t("Məhsullar")}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`/${currentLanguage}/kampaniya`}
                      className="hover:underline"
                    >
                      {t("Kampaniyalar")}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`/${currentLanguage}/blogs`}
                      className="hover:underline"
                    >
                      {t("Bloq")}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`/${currentLanguage}/comments`}
                      className="hover:underline"
                    >
                      {t("Müştəri Rəyləri")}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`/${currentLanguage}/contact`}
                      className="hover:underline"
                    >
                      {t("Əlaqə")}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`/${currentLanguage}/privacy`}
                      className="hover:underline"
                    >
                      {t("Məxfilik")}
                    </a>
                  </li>
                </ul>
              </div>
              <div className="md:w-[170px] mt-10 md:mt-0 text-[#DCDCDC]">
                <h4 className="font-medium text-[18px] text-[#222222]">
                  {t("Məhsullar")}
                </h4>
                <ul className="space-y-2 md:space-y-2 mt-5 text-[#7D7D7D]">
                  {allCategories.map((cat) => (
                    <li key={cat.id}>
                      <a
                        href={`/${currentLanguage}/products?categories=${encodeURIComponent(
                          cat.name
                        )}`}
                        className="hover:underline"
                      >
                        {getLocalizedField(cat, "name")}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="md:w-[238px] mt-10 md:mt-0 text-[#DCDCDC]">
                <h4 className="font-medium text-[18px] text-[#222222]">
                  {t("Əlaqə")}
                </h4>
                <ul className="space-y-2 md:space-y-2 text-[#7D7D7D] mt-5">
                  <div className="flex gap-2 items-center">
                    <img alt="Email" className="w-6 h-6" src={footer4}></img>
                    <p className="text-[#7D7D7D]">{settings.email}</p>
                  </div>
                  <div className="flex gap-2">
                    <img alt="Mobile" className="w-6 h-6" src={footer5}></img>
                    <p className="text-[#7D7D7D]">{settings.mobile}</p>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-containerSm md:max-w-container md:flex justify-between mx-auto py-4 text-sm text-[#222222]">
          <p className="mb-2 md:mb-0">
            ElzaBeauty.az © {t("Bütün hüquqlar qorunur.")}
          </p>
          <a href="https://www.prosayt.az/">
            <p>{t("Sayt hazırlandı")}: Prosayt.az</p>
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
